<template>
    <v-card class="search-container pa-3">
        <v-form
            ref="form"
            @submit.prevent="onSubmit"
        >
            <v-layout
                row
                wrap
            >
                <!-- header -->
                <v-flex xs12>
                    <v-layout
                        column
                        align-center
                    >
                        <v-avatar
                            color="primary"
                            class="mb-2"
                        >
                            <v-icon color="white">
                                fas fa-file-invoice
                            </v-icon>
                        </v-avatar>
                        <h1 class="headline text-xs-center mb-2">
                            Search Invoices
                        </h1>
                    </v-layout>
                </v-flex>
                <!-- invoice number -->
                <v-flex xs12>
                    <v-text-field
                        v-model="invoiceNumber"
                        label="Invoice Number"
                        :rules="[rules.required]"
                        required
                    />
                </v-flex>
                <!-- partner number -->
                <v-flex xs12>
                    <v-text-field
                        v-model="partnerNumber"
                        label="Customer Number"
                        :rules="[rules.required]"
                        required
                        hint="Use your customer # on the printed invoice"
                    />
                </v-flex>
                <!-- submit button -->
                <v-flex xs12>
                    <vue-recaptcha
                        ref="invisibleRecaptcha"
                        :sitekey="sitekey"
                        size="invisible"
                        @verify="onVerify"
                    />
                    <v-btn
                        color="primary"
                        block
                        type="submit"
                        :loading="submitting"
                        :disabled="submitting"
                    >
                        Search
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
import SnackBus from '../../utils/buses/snackBus'
import { requestErrorMessage } from '../../utils/constants/errors'

export default {
    components: {
        VueRecaptcha
    },
    data () {
        return {
            sitekey: process.env.VUE_APP_CAPTCHA_SITEKEY,
            submitting: false,
            partnerNumber: null,
            invoiceNumber: null,
            rules: {
                required: val => !!val || 'This field is required'
            }
        }
    },
    methods: {
        onSubmit () {
            // invalid form
            if (!this.$refs.form.validate()) return

            this.$refs.invisibleRecaptcha.execute()
            this.submitting = true
        },
        // method called once recaptcha has been verified
        onVerify (response) {
            const formData = new FormData()
            formData.set('invoiceNumber', this.invoiceNumber)
            formData.set('partnerNumber', this.partnerNumber)
            formData.set('g-recaptcha-response', response)

            axios.post('/api/returns/validate', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(res => {
                    const data = res.data

                    if (data.gforce.invoiceList.length === 0) {
                        SnackBus.showMessage('Invoice & partner match not found. Please try a different set.')
                        return
                    }

                    // TODO - rework this into a better format?
                    const invoice = {
                        partner: data.gforce.partner,
                        ...data.gforce.invoiceList[0]
                    }
                    this.$emit('found-result', {
                        invoice,
                        productReturn: data.returns.length !== 0
                            ? data.returns[0]
                            : null
                    })
                })
                .catch(err => {
                    console.log('Search Error', err)
                    SnackBus.showMessage(requestErrorMessage, 'error')
                })
                .finally(() => {
                    // check if captcha html exists, it may not if match is found and user is redirect to another page
                    if (this.$refs.invisibleRecaptcha) {
                        this.$refs.invisibleRecaptcha.reset()
                    }
                    this.submitting = false
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    max-width: 500px;
}
</style>
